export default {
    ADD_INFO_AMOUNT: "setInfoAmount",
    ADD_TICKET_DEAL: "setTicketDeal",
    SET_TICKET_ALLSTATE:'setTicketAllState',
    SET_TICKET_ORDERSTATE:'setTicketOrderState',
    SET_TICKET_USESTATE:'setTicketUseState',
    SET_TICKET_CANCELSTATE:'setTicketCancelState',    
}
